export const loadScript = (
  name: string,
  entryPointUrl: string,
  versionAutoGenerated: boolean = true,
) =>
  new Promise<void>((resolve, reject) => {
    if (window[name]) {
      // it was already loaded;
      resolve();
      return;
    }

    const scriptId = `mfe-script-${name}`;
    let script = document.getElementById(scriptId) as HTMLScriptElement;
    if (!script) {
      script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = scriptId;
      script.async = true;
      script.src = versionAutoGenerated
        ? `${entryPointUrl}?v=${new Date().getTime()}`
        : entryPointUrl;
      document.head.appendChild(script);
    }

    const loadListener = () => {
      resolve();
      script.removeEventListener('load', loadListener);
      script.removeEventListener('error', errorListener);
    };

    const errorListener = () => {
      reject();
      script.removeEventListener('load', loadListener);
      script.removeEventListener('error', errorListener);
    };

    script.addEventListener('load', loadListener);
    script.addEventListener('error', errorListener);
  });
